"use strict";
/*
 * Created on 01 15 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../../../core/modules/AppModule");

var ValidationResultConverter_1 = require("./conversions/ValidationResultConverter");

var ValidationResultConverterImpl_1 = require("./conversions/ValidationResultConverterImpl");

var ValidationResultObjectConverter_1 = require("./conversions/ValidationResultObjectConverter");

var ValidationResultObjectConverterImpl_1 = require("./conversions/ValidationResultObjectConverterImpl");
/**
 * Configures errors app module.
 *
 * @author JMe
 */


var ErrorsAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ErrorsAppModule, _AppModule_1$AppModul);

  function ErrorsAppModule() {
    var _this;

    _classCallCheck(this, ErrorsAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorsAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'errorsAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ErrorsAppModule, [{
    key: "configure",
    value: function configure() {
      this.configureValidationRelatedParts();
    }
  }, {
    key: "configureValidationRelatedParts",
    value: function configureValidationRelatedParts() {
      typescript_ioc_1.Container.bind(ValidationResultConverter_1.ValidationResultConverter).to(ValidationResultConverterImpl_1.ValidationResultConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ValidationResultObjectConverter_1.ValidationResultObjectConverter).to(ValidationResultObjectConverterImpl_1.ValidationResultObjectConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ErrorsAppModule;
}(AppModule_1.AppModule);

exports.ErrorsAppModule = ErrorsAppModule;